import { ALLOWED_DOMAINS } from "@/constants/contact-form.constant";
import { z } from "zod";

const INVALID_EMAIL = "Invalid email format";
const INVALID_DOMAIN = "Please use Gmail, Outlook, iCloud or similar email";

export const ContactFormInputModel = z.object({
  name: z.string().min(2, "Name is required").max(100),
  email: z.email(INVALID_EMAIL).refine((s) => {
    const domainMatches = s.match(/@(.+)$/);
    if (!domainMatches || !domainMatches[1]) {
      return false;
    }
    return ALLOWED_DOMAINS.includes(domainMatches[1].toLowerCase());
  }, INVALID_DOMAIN),
  message: z.string().min(1, "Message is required").max(100, "Max 100 characters"),
  recaptchaToken: z.string(),
});
export type ContactFormInput = z.infer<typeof ContactFormInputModel>;

export const ContactFormErrorsModel = z.object({
  name: z.string().optional(),
  email: z.string().optional(),
  message: z.string().optional(),
});
export type ContactFormErrors = z.infer<typeof ContactFormErrorsModel>;

export const ContactFormOutputModel = z.object({
  ok: z.boolean(),
  errors: ContactFormErrorsModel.optional(),
  message: z.string().optional(),
});
export type ContactFormOutput = z.infer<typeof ContactFormOutputModel>;
